import { fromJS } from "immutable";
import types from "./types";

export const initialState = fromJS({
  allIds: [],
  byId: {},
});

export default (state = initialState, action) => {
  const type = action.type;

  switch (type) {
    case types.TOGGLE_EDIT: {
      return state.withMutations((state) => {
        state.setIn(["byId", action.sectionId, "editing"], action.bool);
      });
    }
    case types.UPDATE_BODY: {
      return state.withMutations((state) => {
        state.setIn(["byId", action.sectionId, "body"], action.content);
      });
    }

    default: {
      return state;
    }
  }
};
